module.exports = __webpack_public_path__ + "static/images/containers/ClanLanding/components/AnnouncementsCard/images/icon_lock.2cea50ab.png";


//////////////////
// WEBPACK FOOTER
// ./containers/ClanLanding/components/AnnouncementsCard/images/icon_lock.png
// module id = 2897
// module chunks = 11